// Échelle de coma de Glasgow (adulte), libellés d'après le Manuel MSD
// (édition professionnelle, version française).
export const ITEMS = [
  {
    key: "E",
    title: "Ouverture des yeux",
    options: [
      { score: 4, label: "Spontanée", detail: "Les yeux s'ouvrent spontanément" },
      { score: 3, label: "À la demande", detail: "Les yeux s'ouvrent à la parole" },
      { score: 2, label: "À la douleur", detail: "Ouverture en réponse à la douleur" },
      { score: 1, label: "Aucune", detail: "Pas d'ouverture des yeux" },
    ],
  },
  {
    key: "V",
    title: "Réponse verbale",
    options: [
      { score: 5, label: "Orientée", detail: "Sait qui il est, où il est, la date" },
      { score: 4, label: "Confuse", detail: "Désorientée, mais répond aux questions" },
      { score: 3, label: "Mots inappropriés", detail: "Réponses inadaptées aux questions" },
      { score: 2, label: "Sons incompréhensibles", detail: "Gémissements, grognements" },
      { score: 1, label: "Aucune", detail: "Pas de réponse verbale" },
    ],
  },
  {
    key: "M",
    title: "Meilleure réponse motrice",
    options: [
      { score: 6, label: "Obéit aux ordres", detail: "Exécute les consignes simples" },
      { score: 5, label: "Orientée à la douleur", detail: "Localise la douleur, mouvement intentionnel" },
      { score: 4, label: "Évitement", detail: "Retrait au stimulus douloureux" },
      { score: 3, label: "Flexion anormale", detail: "Posture de décortication" },
      { score: 2, label: "Extension", detail: "Posture de décérébration" },
      { score: 1, label: "Aucune", detail: "Pas de réponse motrice" },
    ],
  },
];

// A value per item: a score, "NT" (non testable, e.g. verbal response in an
// intubated patient) or undefined while not yet assessed.
export function evaluate(values) {
  const assessed = ITEMS.every((i) => values[i.key] !== undefined);
  const testable = ITEMS.every((i) => typeof values[i.key] === "number");
  const total = testable ? ITEMS.reduce((sum, i) => sum + values[i.key], 0) : null;
  const notation = ITEMS.map((i) => `${i.key}${values[i.key] === undefined ? "?" : values[i.key]}`).join(" ");
  return { assessed, testable, total, notation, severity: total === null ? null : severityFor(total) };
}

// Gravité conventionnelle (traumatisme crânien). Un score ≤ 8 définit le coma.
export function severityFor(total) {
  if (total === 15) return { key: "normal", label: "Conscience normale" };
  if (total >= 13) return { key: "mild", label: "Atteinte légère" };
  if (total >= 9) return { key: "moderate", label: "Atteinte modérée" };
  return { key: "severe", label: "Atteinte grave (coma)" };
}
